import lodash from 'lodash'
import { DocksData } from './DockManagementTypes'

export const sortDocks = (dokList: DocksData[]): DocksData[] => lodash.orderBy(dokList, ['fulfillmentCenterName', 'dockCode'], ['asc', 'asc'])
